<template lang="html">

<div id="buildings">

      <el-row class="headLine">
          <el-col :span="12">
              <!-- <div class="inpName">空置总面积：</div> -->
              <div class="inpContent">
                  <el-select clearable @change="areaChange" v-model="areaKey" size="medium" placeholder="请选择">
                     <el-option
                       v-for="item in areaOptions"
                       :key="item.val"
                       :label="item.name"
                       :value="item.val">
                     </el-option>
                   </el-select>
              </div>
              <!-- <span>可租售面积集中在5000平米以上的已建成商务楼宇情况表</span> -->
          </el-col>
          <el-col :span="12" style="text-align:right;">
              <el-button @click="reList" size="small" type="sccess">刷新</el-button>
          </el-col>
      </el-row>

      <div class="pgContent">

        <el-table border
            header-cell-class-name="dHead"
            v-loading="loading"
            :data="tbData">

            <el-table-column fixed="left" align="center" width="60" label="序号">
                <template slot-scope="scope">
                     {{ scope.$index + (params.no - 1)*params.size + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="buildingName" fixed="left" align="center" min-width="150" label="楼宇名称" />
            <el-table-column prop="park" align="center" width="150" label="所属功能区" />
            <el-table-column prop="jiexiang" align="center" width="90" label="位置" />
            <el-table-column prop="propertyUnit" align="center" min-width="120" label="产权单位" />
            <el-table-column prop="totalVacantArea" align="center" width="150" label="招商总面积(平方米)" />
            <el-table-column prop="statistics" align="center" width="180" label="租金或售价" >
                <template slot-scope="scope">
                       {{ scope.row.statistics | statusTrans }}
                   </template>
               </el-table-column>

        </el-table>

        <div class="table-footer">

           <el-pagination
             class="paging"
             v-if="allPages>1"
             @current-change="pageChange"
             :current-page="params.no"
             :page-size="params.size"
             layout="total, prev, pager, next, jumper"
             :total="params.allEls">
           </el-pagination>

       </div>



      </div>

</div>

</template>

<script>
import { getBuildings } from '@/api/industryInfos';
export default {
    data(){
        return{
            tbData:[],
            allPages:0,
            params:{
                buildingName:'',
                jiexiangId:'',
                locationId:'',
                parkId:'',
                totalVacantArea1:'3000',
                totalVacantArea2:'',
                status:2,
                no:1,
                size:10,
                allEls:0
            },
            areaKey:2,
            areaOptions:[
               { name:'不限',val:0 },
               { name:'1000 ㎡以上',val:1 },
               { name:'3000 ㎡以上',val:2 },
               { name:'5000 ㎡以上',val:3 },
               { name:'10000 ㎡以上',val:4 },
               { name:'30000 ㎡以上',val:5 },
               { name:'50000 ㎡以上',val:6 },
            ],
        }
    },
    filters:{
      statusTrans(e){
          let arr=e.split(',');
          var ret=e;
          if(arr.length>0){
            ret=arr.join('\n');
          }
          
          
          return ret;
      }
    },
    methods:{
      pageChange(e){
         this.params.no = e;
         this.getList();
      },
        areaChange(e){
            let map = {
                1: [1000,''],
                2: [3000,''],
                3: [5000,''],
                4: [10000,''],
                5: [30000,''],
                6: [50000,''],
            }
            if(e){
                this.params.totalVacantArea1 = map[e][0];
                this.params.totalVacantArea2 = map[e][1];
            }else{
                this.params.totalVacantArea1 = '';
                this.params.totalVacantArea2 = '';
            }
            this.getList();
        },
      getList(){
          this.loading = true;
          getBuildings(this.params).then(res => {
              this.loading = false;
              this.tbData = res.industrialSpaceList;
              this.params.allEls = res.totalElements;
              this.allPages = res.totalPages;
          })
      },

      reList(){
          this.params.no = 1;
          this.getList();
      }
    },

    created(){
      this.getList();
    }
}
</script>

<style lang="scss" scoped>

#buildings{
    font-size: 15px;

    .headLine{
        padding: 0 20px;
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid #EBEEF5;
    }
    .seekLine{
        padding: 20px;
        padding-bottom: 0px;
        border-bottom: 1px solid #EBEEF5;
        .inpItem{
            padding-right: 20px;
            margin-bottom: 20px;
            .inpName{
                width: 120px;
                float: left;
                font-size: 14px;
                text-align: right;
                padding-top: 6px;
            }
            .inpContent{
                margin-left: 120px;
            }
        }

    }

    .pgContent{
        padding: 20px;

        .table-footer{
            margin-top: 20px;
            text-align: right;
        }
    }

}

</style>

<style lang="scss">

#buildings{
    .el-input__inner{
        border-radius: 0px;
    }
    .dHead{
        background: #f5f5f5;
        font-weight: normal;
    }
}

</style>



// WEBPACK FOOTER //
// index.vue?68edf06a